export const MASTER_TABLE_SCHEMA = 'master tables';

class TableRef {
  readonly _schema: string;

  readonly _name: string;

  constructor(schema: string, name: string) {
    this._schema = schema;
    this._name = name;
  }

  static buildFromServer(serverObj: TableRef) {
    return new TableRef(serverObj._schema, serverObj._name);
  }

  schema() {
    return this._schema;
  }

  name() {
    return this._name;
  }

  isMasterTable() {
    return MASTER_TABLE_SCHEMA === this.schema();
  }

  equals(t: Nullable<TableRef>) {
    if (!t) {
      return false;
    }
    // TODO: get rid of this condition.
    if (!(t instanceof TableRef)) {
      return false;
    }
    if (this.name() !== t.name()) {
      return false;
    }
    return this.schema() === t.schema();
  }

  uniqueName() {
    return `${this.schema()}.${this.name()}`;
  }
}

export default TableRef;
